<template>
	<div class="spinner-element">
		<div class="bounce1" />
		<div class="bounce2" />
		<div class="bounce3" />
	</div>
</template>
